import * as RW from './';

export default class Reportwesen {
    constructor() {
        if (document.querySelectorAll('#rw-bar').length) {
            new RW.Bar();
            new RW.LayerAction();
        }
        if (document.querySelectorAll('.rw-container').length) {
            new RW.PostProcessing();
            new RW.ShadowDom();
            new RW.TopBar();
            new RW.EntryRemove();
        }
        new RW.Graph();

    }
}
